export const FETCH_CARD_TIERS_LIST = 'FETCH_CARD_TIERS_LIST';
export const FETCH_CARD_TIERS_LIST_SUCCESS = 'FETCH_CARD_TIERS_LIST_SUCCESS';
export const FETCH_CARD_TIERS_LIST_FAILURE = 'FETCH_CARD_TIERS_LIST_FAILURE';
export const CLEAR_CARD_TIERS_LIST = 'CLEAR_CARD_TIERS_LIST';
